const o=40;export{o as OFFSET};
